import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '../common/common.module';
import { AppCardComponent } from './appCard/appCard.component';
import { HomeClassicComponent } from './homeClassic.component';
import { TourModule } from '../tour/tour.module';
import { DashboardCommonModule } from '../dashboardCommon/dashboardCommon.module';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        NgbModule,
        TourModule,
        DashboardCommonModule
    ],
    exports: [
        HomeClassicComponent,
        AppCardComponent
    ],
    declarations: [
        HomeClassicComponent,
        AppCardComponent
    ]
})
export class HomeClassicModule {

}